(() => {
  const data = document.getElementById('im-filter-terms');
  if (!data || window.imFilterTermsReady) return;
  window.imFilterTermsReady = true;
  const terms = JSON.parse(data.textContent);
  const labelSelector = '.boost-sd__filter-tree-vertical-toolbar-middle, .boost-sd__filter-option-title, .boost-sd__filter-option-item-label, .boost-sd__filter-option-mobile-items-selected, [class*="boost-sd__refine-by-"][class$="-option"], [class*="boost-sd__refine-by-"][class$="-value"]';
  const scopeSelector = '.boost-sd__filter-tree-vertical-mobile-toolbar, .boost-sd__filter-option, [class*="boost-sd__refine-by-"]';
  function translate(value) {
    const text = value.trim();
    if (['Abito', terms.Abito, terms['Abito donna'], terms['Abito uomo']].includes(text)) {
      const url = new URL(window.location.href);
      const gender = url.searchParams.get('pf_t_genere') || (/\/donna(?:\/|$)/i.test(url.pathname) ? 'Donna' : /\/uomo(?:\/|$)/i.test(url.pathname) ? 'Uomo' : '');
      return gender === 'Donna' ? terms['Abito donna'] : gender === 'Uomo' ? terms['Abito uomo'] : terms.Abito;
    }
    return terms[text] || text;
  }
  function localizeText(element) {
    for (const node of element.childNodes) {
      if (node.nodeType !== Node.TEXT_NODE) continue;
      const original = node.nodeValue;
      const text = original.trim();
      const suffix = text.endsWith(':') ? ':' : '';
      const source = suffix ? text.slice(0, -1) : text;
      const translated = element.matches('.boost-sd__filter-option-mobile-items-selected')
        ? source.split(',').map(translate).join(', ')
        : translate(source);
      if (translated !== source) node.nodeValue = original.replace(text, translated + suffix);
    }
  }
  function localize() {
    observer.disconnect();
    document.querySelectorAll(labelSelector).forEach(element => {
      const option = element.closest('.boost-sd__filter-option');
      const title = option?.querySelector('.boost-sd__filter-option-title');
      if (element.matches('.boost-sd__filter-option-item-label, .boost-sd__filter-option-mobile-items-selected') && title && [terms.Brand, 'Brand'].includes(title.textContent.trim())) return;
      localizeText(element);
    });
    document.querySelectorAll(scopeSelector).forEach(scope => {
      [scope, ...scope.querySelectorAll('[aria-label], [title]')].forEach(element => {
        for (const attr of ['aria-label', 'title']) {
          const value = element.getAttribute(attr);
          if (!value) continue;
          let next = value;
          if (value === 'Clear all filters') next = terms['Cancella tutti i filtri'];
          else if (value === 'Min value') next = terms['Valore minimo'];
          else if (value === 'Max value') next = terms['Valore massimo'];
          else if (value.startsWith('Filter by: ')) next = terms['Filtra per'] + ': ' + translate(value.slice(11));
          else if (value.startsWith('Clear filter by ')) next = terms['Cancella filtro'] + ': ' + translate(value.slice(16));
          else if (value.startsWith('Number of products: ')) next = terms['Numero prodotti'] + ': ' + value.slice(20);
          else if (attr === 'title') next = translate(value);
          if (next !== value) element.setAttribute(attr, next);
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (scheduled) return;
    const relevant = records.some(record => {
      const parent = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      return parent?.closest(scopeSelector) || [...record.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE && (node.matches(scopeSelector) || node.querySelector(scopeSelector)));
    });
    if (!relevant) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; localize(); });
  });
  localize();
})();
